import { render, staticRenderFns } from "./InactiveFBMUsersTableSection.vue?vue&type=template&id=02ee9470&scoped=true"
import script from "./InactiveFBMUsersTableSection.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee9470",
  null
  
)

export default component.exports